/* eslint-disable @typescript-eslint/no-require-imports */
// In the browser, use the runtime config injected by _document.js into
// window.__APP_CONFIG__ — this prevents values from being baked into the bundle.
// On the server (SSR), read config.json at runtime so no values are bundled.
const getConfig = () => {
  if (typeof window !== 'undefined') return window.__VUO_APP_CONFIG__;
  try {
    const fs = require('fs');
    const path = require('path');
    return JSON.parse(
      fs.readFileSync(path.join(process.cwd(), 'config/config.json'), 'utf8')
    );
  } catch {
    return {};
  }
};

export default getConfig();
